// Primary Colors
const scGreen = '#79c909';
const scGreenLight = '#87d41c';
const scGreenDark = '#79bd19';
const scPink = '#ee207a';
const scRed = '#D33F49';
const scYellow = '#ffce00';
const scOrange = '#F18F01';
const scNavy = '#29335C';
const scBlue = '#78C0E0';
const scLightGreen = '#e7f6db';
const scGray = '#506160';
const scWhite = '#FFF';
const scBlack = '#333';

// Greyscale Colors
const scDarkGray4 = '#24292A';
const scDarkGray3 = '#3A4546';
const scDarkGray2 = '#506160';
const scDarkGray1 = '#819697';
const scLightGray1 = '#9EADAE';
const scLightGray2 = '#B9C4C5';
const scLightGray3 = '#D5DCDC';
const scLightGray4 = '#F1F3F3';

// Supporting Colors
const linkedInBlue = '#0077b5';

const styles = {
    'primary-color': scGreen,
    'secondary-color': scPink,
    'color': {
        scGreen,
        scGreenLight,
        scGreenDark,
        scLightGreen,
        scRed,
        scPink,
        scYellow,
        scOrange,
        scNavy,
        scBlue,
        scWhite,
        scBlack,
        scDarkGray4,
        scDarkGray3,
        scDarkGray2,
        scDarkGray1,
        scGray,
        scLightGray1,
        scLightGray2,
        scLightGray3,
        scLightGray4,
        primary: scGreen,
        primaryLight: scGreenLight,
        primaryDark: scGreenDark,
        secondary: scPink,
        linkedInBlue,
    },
    'navbar': {
        sm: '60px',
        med: '80px',
        lrg: '80px',
        xlrg: '90px',
    },
    'padding': {
        xs: '2px',
        sm: '5px',
        med: '10px',
        lrg: '20px',
        xlrg: '30px',
        xxlrg: '50px',
    },
    'margin': {
        xs: '2px',
        sm: '5px',
        med: '10px',
        lrg: '20px',
        xlrg: '30px',
        xxlrg: '50px',
    },
    'border': {
        xs: '1px',
        sm: '2px',
        med: '3px',
        lrg: '5px',
        xlrg: '10px',
        xxlrg: '20px',
    },
    'font': {
        xxxs: '10px',
        xxs: '12px',
        xs: '14px',
        sm: '18px',
        med: '24px',
        lrg: '36px',
        xlrg: '54px',
        xxlrg: '72px',
        xxxlrg: '100px',
    },
    'image': {
        xxxs: '16px',
        xxs: '32px',
        xs: '48px',
        sm: '72px',
        med: '96px',
        lrg: '144px',
        xlrg: '172px',
        xxlrg: '256px',
        xxxlrg: '360px',
    },
    'width': {
        xxs: '360px',
        xs: '420px',
        sm: '600px',
        med: '768px',
        lrg: '1024px',
        xlrg: '1366px',
        phone: '480px',
        tablet: '768px',
        desktop: '1024px',
    },
};

export default styles;



// WEBPACK FOOTER //
// ./src/styles/styles.js